import { render, staticRenderFns } from "./RecommendationView.vue?vue&type=template&id=48f395bc&scoped=true&"
import script from "./RecommendationView.vue?vue&type=script&lang=js&"
export * from "./RecommendationView.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationView.vue?vue&type=style&index=0&id=48f395bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f395bc",
  null
  
)

export default component.exports